/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PushNotificationCategorySource = {
    _11184809: '11184809',
    BUILT_IN: 'BUILT_IN',
    CUSTOM: 'CUSTOM',
    unknown_default_open_api: '11184809'
} as const;
export type PushNotificationCategorySource = typeof PushNotificationCategorySource[keyof typeof PushNotificationCategorySource];


export function instanceOfPushNotificationCategorySource(value: any): boolean {
    for (const key in PushNotificationCategorySource) {
        if (Object.prototype.hasOwnProperty.call(PushNotificationCategorySource, key)) {
            if (PushNotificationCategorySource[key as keyof typeof PushNotificationCategorySource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PushNotificationCategorySourceFromJSON(json: any): PushNotificationCategorySource {
    return PushNotificationCategorySourceFromJSONTyped(json, false);
}

export function PushNotificationCategorySourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PushNotificationCategorySource {
    return json as PushNotificationCategorySource;
}

export function PushNotificationCategorySourceToJSON(value?: PushNotificationCategorySource | null): any {
    return value as any;
}

